<div class="section-965-tax-db-container">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (show965Table && !showFormLoader) {
<div class="table-responsive">
    <form #section965Form="ngForm" novalidate autocomplete="off">
      <hr>
      <table class="table table-hover table-bordered table-striped table-condensed custom-table">
        <thead>
          <tr>
            <th>Statement</th>
            <th class="text-center">Total</th>
            <th class="text-center">IND</th>
            <th class="text-center">FIN</th>
            <th class="text-center"></th>
          </tr>
        </thead>

        @for (schdC of schdData; track $index; let i = $index) {
<tbody>
          @if (schdC.ROW_ORDER !== 9) {
<tr>
            <td>
              <span>{{ schdC.ROW_NAME }}</span>
            </td>

            <td class="text-right">
              @if (schdC.ROW_ORDER === 1 || schdC.ROW_ORDER === 3 || schdC.ROW_ORDER === 4 || schdC.ROW_ORDER === 5 || schdC.ROW_ORDER === 6) {
<span>
                {{ schdC.TOTAL_AMOUNT | number: '1.0-0' }}
              </span>
}
              @if (schdC.ROW_ORDER === 2) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_total'"
                [(ngModel)]="TOTAL_AGG_FOREIGN_CASH">
}
              @if (schdC.ROW_ORDER === 7) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_total'"
                [(ngModel)]="TOTAL_NET_SECTION965H">
}
              @if (schdC.ROW_ORDER === 8) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_total'"
                [(ngModel)]="TOTAL_NET_SECTION965I">
}
              @if (invalidTotalByRow[schdC.ROW_ORDER]) {
<span class="form-error-container">
                Amount does not equal to IND and FIN Total.
              </span>
}
            </td>

            <td class="text-right">
              @if (schdC.ROW_ORDER === 1 || schdC.ROW_ORDER === 3 || schdC.ROW_ORDER === 4 || schdC.ROW_ORDER === 5 || schdC.ROW_ORDER === 6) {
<span>
                {{ schdC.GE_TOTAL_AMOUNT | number: '1.0-0' }}
              </span>
}
              @if (schdC.ROW_ORDER === 2) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_ge_total'"
                [(ngModel)]="GE_AGG_FOREIGN_CASH">
}
              @if (schdC.ROW_ORDER === 7) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_ge_total'"
                [(ngModel)]="GE_TOTAL_NET_SECTION965H">
}
              @if (schdC.ROW_ORDER === 8) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_ge_total'"
                [(ngModel)]="GE_TOTAL_NET_SECTION965I">
}
            </td>

            <td class="text-right">
              @if (schdC.ROW_ORDER === 1 || schdC.ROW_ORDER === 3 || schdC.ROW_ORDER === 4 || schdC.ROW_ORDER === 5 || schdC.ROW_ORDER === 6) {
<span>
                {{ schdC.GECS_TOTAL_AMOUNT | number: '1.0-0' }}
              </span>
}
              @if (schdC.ROW_ORDER === 2) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_gecs_total'"
                [(ngModel)]="GECS_AGG_FOREIGN_CASH">
}
              @if (schdC.ROW_ORDER === 7) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_gecs_total'"
                [(ngModel)]="GECS_TOTAL_NET_SECTION965H">
}
              @if (schdC.ROW_ORDER === 8) {
<input
               
                type="number"
                class="form-control input-sm text-right"
                [name]="'row_order_' + schdC.ROW_ORDER + '_gecs_total'"
                [(ngModel)]="GECS_TOTAL_NET_SECTION965I">
}
            </td>

            <td>
              @if (schdC.ROW_ORDER === 2 || schdC.ROW_ORDER === 7 || schdC.ROW_ORDER === 8) {
<button
               
                class="save-button"
                type="button"
                [disabled]="crudLoading"
                (click)="save(schdC)">
                @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save Amounts
              </button>
}
            </td>
          </tr>
}

          @if (schdC.ROW_ORDER === 9 && (schdC.ELECTION_TYPE_CNT === 0 || schdC.ELECTION_TYPE_CNT === schdC.ELECTION_TYPE_NUMBER)) {
<tr>
            <td>
              <span>{{ schdC.ROW_NAME }}</span>
            </td>
            <td colspan="4"></td>
          </tr>
}
        </tbody>
}

        @for (row of electionLines; track $index; let idx = $index) {
<tbody>
          <tr>
            <td>
              <input
                type="text"
                class="form-control input-sm"
                [name]="'elections_' + row.ELECTIONNO"
                [ngModel]="election[row.ELECTIONNO]"
                (ngModelChange)="election[row.ELECTIONNO] = $event">
            </td>
            <td colspan="4"></td>
          </tr>
          @if (idx === electionLines.length - 1) {
<tr>
            <td>
              <button class="save-button" type="button" [disabled]="crudLoading" (click)="save(row)">
                @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save Elections
              </button>
            </td>
            <td colspan="4"></td>
          </tr>
}
        </tbody>
}
      </table>
    </form>
  </div>
}
</div>
